var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaderStyle === "spinner"
    ? _c("div", { staticClass: "vue-loader--spinner" }, [
        _c("div", { staticClass: "sk-circle1 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle2 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle3 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle4 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle5 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle6 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle7 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle8 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle9 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle10 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle11 sk-circle" }),
        _vm._v(" "),
        _c("div", { staticClass: "sk-circle12 sk-circle" })
      ])
    : _c("div", { staticClass: "vue-loader--dots" }, [
        _c("div", { staticClass: "dot1" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot2" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot3" })
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }